import { Button } from "@mui/material";

import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const compactSidebarQuery =
    "@media (max-width: 1200px), (max-height: 768px)";

export const Container = styled.div<{
    isSidebarOpen?: boolean;
    shouldShowHeaderBurger?: boolean;
    isWizardRoute?: boolean;
}>`
    /* Align with in-page ExitButton cutover at 1000px — hide wizard sidebar below it. */
    ${({ isWizardRoute }) =>
        isWizardRoute &&
        `
        @media (max-width: 999px) {
            display: none !important;
        }
    `}

    @media (max-width: 991px) {
        display: ${({ shouldShowHeaderBurger }) =>
            shouldShowHeaderBurger ? "flex" : "none"};
        flex-flow: column nowrap;
        background-color: #fff;
        position: fixed;

        transform: ${({ isSidebarOpen }) =>
            isSidebarOpen ? "translateX(0)" : "translateX(100%)"};
        top: 0;
        right: 0;
        box-shadow: -4px 0 16px rgba(0, 0, 0, 0.12);
        height: 100vh;
        width: 300px;
        padding-top: 3.5rem;
        transition: transform 0.3s ease-in-out;
        z-index: 2000;
    }
`;

export const Panel = styled.div<{ isHidden?: boolean }>`
    display: ${({ isHidden }) => (isHidden ? "none" : "flex")};
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 300px;
    z-index: 90;
    background: #f6f7f9;
    border: 0;
    box-shadow:
        0 1px 15px rgba(0, 0, 0, 0.04),
        0 1px 6px rgba(0, 0, 0, 0.04);
    padding: 30px 15px;
    transition: all 0.2s ease-in;

    @media (max-width: 991px) {
        position: static;
        width: 100%;
        height: 100%;
        z-index: auto;
        background: transparent;
        box-shadow: none;
        padding-bottom: 100px;
    }

    @media (max-width: 480px) {
        padding-bottom: 80px;
    }

    ${compactSidebarQuery} {
        padding: 20px 12px;
    }
`;

export const LogoWrap = styled.div`
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;

    ${compactSidebarQuery} {
        margin-top: 12px;
        margin-bottom: 12px;

        img {
            width: 130px !important;
        }
    }
`;

export const SideNav = styled.div`
    margin-top: 2rem;
`;

export const ScrollArea = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;

    @media (max-width: 768px) {
        padding-bottom: 80px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    @media (max-width: 480px) {
        padding-bottom: 70px;
    }
`;

export const MainMenuList = styled.ul`
    list-style: none;
    padding: 0 7px 0 0;
`;

export const MenuItem = styled.li`
    margin-top: 1rem;
`;

export const MenuLink = styled(Link)`
    display: flex;
    align-items: center;
    min-height: 45px;
    padding: 12px 16px;
    margin-bottom: 10px;
    border-radius: 5px !important;
    cursor: pointer;
    color: #000;
    text-decoration: none;
    transition:
        background-color 200ms cubic-bezier(0.4, 0, 0.2, 1),
        color 200ms cubic-bezier(0.4, 0, 0.2, 1);

    svg.MuiSvgIcon-root {
        margin-right: 15px;
        color: #000;
    }

    &:not([data-active="true"]):hover {
        background-color: rgba(0, 0, 0, 0.04) !important;
    }

    &[data-active="true"] {
        background: #fff;
    }

    &[data-active="true"] svg.MuiSvgIcon-root {
        color: #f66700;
    }

    &[data-active="true"] span {
        font-weight: 700 !important;
    }

    ${compactSidebarQuery} {
        height: 40px !important;
        min-height: 40px !important;
        padding: 0 10px !important;

        svg.MuiSvgIcon-root {
            font-size: 18px !important;
            margin-right: 8px !important;
        }
    }
`;

export const MenuLabel = styled.span`
    font-size: 14px;
    font-weight: 600;
`;

export const MenuGroupItem = styled.li`
    margin-bottom: 0.5rem;
`;

export const MenuGroupTrigger = styled.p<{ isOpen?: boolean }>`
    display: flex;
    align-items: center;
    min-height: 45px;
    padding: 12px 16px;
    margin: 0;
    border-radius: 5px !important;
    cursor: pointer;
    color: #000;
    font-size: 14px;
    font-weight: 600;
    user-select: none;
    transition:
        background-color 200ms cubic-bezier(0.4, 0, 0.2, 1),
        color 200ms cubic-bezier(0.4, 0, 0.2, 1);

    svg.MuiSvgIcon-root {
        margin-right: 15px;
        color: #000;
    }

    svg.fa-chevron-down {
        margin-left: auto;
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.04) !important;
    }

    &[data-open="true"] {
        background: #fff;
    }

    &[data-open="true"] svg.MuiSvgIcon-root {
        color: #f66700 !important;
    }

    ${compactSidebarQuery} {
        height: 40px !important;
        min-height: 40px !important;
        padding: 0 10px !important;

        svg.MuiSvgIcon-root {
            font-size: 18px !important;
            margin-right: 8px !important;
        }

        svg.fa-chevron-down {
            font-size: 12px !important;
        }
    }
`;

export const SubmenuList = styled.ul`
    margin: 0;
    padding: 4px 0 0;
    list-style: none;

    li {
        background: #fff;
        border-radius: 5px !important;
        margin: 0;
    }

    li + li {
        margin-top: 5px;
    }

    li a {
        display: flex;
        align-items: center;
        margin: 0 !important;
        padding: 12px 10px !important;
        font-weight: 400 !important;
        background: #eff1f5;
        border-radius: 5px;
        text-decoration: none;
        color: #000;
        transition:
            background-color 200ms cubic-bezier(0.4, 0, 0.2, 1),
            color 200ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    li a span {
        font-weight: 400;
        text-transform: initial;
    }

    li a svg.MuiSvgIcon-root {
        color: #000;
        opacity: 0.2;
        margin-right: 15px;
    }

    li:not([data-active="true"]):hover a {
        background-color: rgba(0, 0, 0, 0.08) !important;
    }

    li[data-active="true"] a {
        background: #fff !important;
    }

    li[data-active="true"] a svg {
        color: #f66802 !important;
        opacity: 1 !important;
    }

    li[data-active="true"] a span {
        font-weight: 800 !important;
    }

    ${compactSidebarQuery} {
        li a {
            height: 40px !important;
            min-height: 40px !important;
            padding: 0 8px !important;
        }

        li a svg.MuiSvgIcon-root {
            font-size: 16px !important;
            margin-right: 8px !important;
        }
    }
`;

export const BottomArea = styled.div`
    flex-shrink: 0;
    border-top: 2px solid #dbdbdb;
    padding-top: 20px;
    position: relative;

    & .notification-dropdown {
        bottom: -15px !important;
        left: calc(100% + 30px) !important;
        top: initial !important;
        background: #fff !important;
        border: 0 !important;
        width: fit-content;
        max-width: 800px;
    }

    ${compactSidebarQuery} {
        padding-top: 10px !important;

        & button.help,
        & button.account {
            padding: 8px 12px !important;
            margin-bottom: 6px !important;
        }

        & button.help svg.MuiSvgIcon-root,
        & button.account svg.MuiSvgIcon-root {
            font-size: 18px !important;
        }
    }
`;

export const WizardTextArea = styled.div<{ isNested?: boolean }>`
    margin-top: ${({ isNested }) => (isNested ? "1rem" : "0")};
    margin-bottom: 10px;
    padding: 0 16px;

    p {
        font-size: 14px;
        font-family: "Nunito", sans-serif;
        color: #000;
    }

    p + p {
        margin-top: 15px;
    }

    img {
        margin: 30px 0;
        max-width: 100%;
        height: auto;
    }
`;

export const WizardTitle = styled.h1`
    margin-top: 2rem;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    font-family: "Nunito", sans-serif;
    color: #000;

    ${compactSidebarQuery} {
        font-size: 20px;
        margin-bottom: 12px;
    }
`;

export const LeadsWizardImage = styled.img`
    margin-bottom: 1rem;
`;

export const LeadsWizardParagraph = styled.p<{
    noTopMargin?: boolean;
    noBottomMargin?: boolean;
}>`
    ${({ noTopMargin }) => noTopMargin && `margin-top: 0;`}
    ${({ noBottomMargin }) => !noBottomMargin && `margin-bottom: 0.25rem;`}
`;

export const WizardButtonBottom = styled.div`
    position: absolute;
    bottom: 50px;
    left: 15px;
    right: 15px;

    @media (max-width: 768px) {
        position: fixed;
        bottom: 20px;
        left: 20px;
        right: 20px;
        z-index: 1000;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        padding: 15px;
        border-radius: 8px;
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 480px) {
        bottom: 15px;
        left: 15px;
        right: 15px;
        padding: 12px;
    }
`;

export const WizardExitButton = styled(Button)`
    padding: 10px !important;
    color: rgba(0, 0, 0, 0.87) !important;
    border: 1px solid rgba(0, 0, 0, 0.5) !important;
    font-weight: 500 !important;
    font-family: "Nunito", sans-serif !important;
    border-radius: 4px !important;

    @media (max-width: 768px) {
        width: 100%;
        padding: 12px 20px !important;
        font-size: 16px !important;
        min-height: 44px;
    }
`;
